<div class="reference_body">
  <main class="reference_main">
<div class="pink_box"></div>
<div class="green_box"></div>

<div class="main">

 <div class="reference_table">
   <div class="page_content">
    <div class="top_part">
     <div class="search_scholarship_name scholarship_search ml-auto">
            <input type="search" name="search" id="nav_search search" (keyup)="search($event.target.value)"  placeholder="Search for Beneficiary Name">
            <span class="search_icon"><img src="assets/images/top_nav/Magnifiction.svg" alt=""
                    class="magnify"></span>
        </div>


        <span><mat-checkbox class=" mr-5" (change)="OnChange($event)"></mat-checkbox></span>

        <div class="scholarship_buttons pull-right">
            <button class="new_addition mr-3" (click)="createEvent()"><em class="ti-plus mr-2" ></em> Create New </button>
            <button class="upload_excel" (click)="uploadEvent()"><img src="assets/images/components/icons8-microsoft-excel-50.png"
                    height="20px" alt="" >Upload Excel</button>
        </div>

    </div>

    <div class="scholarship_search_result cursor" *ngFor="let scholarship of searchScholarshipManagement" (click)="onView(scholarship)">
        <h4 class="beneficiary_name"  >{{scholarship.BeneficarySurname}} {{scholarship.BeneficaryFirstname}} {{scholarship.BeneficaryOthername}} </h4>
      <div class="option_button">
        <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopImmediatePropagation()" class="ml-auto" aria-label="Example icon-button with a menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="onEdit(scholarship)">
            <mat-icon>edit</mat-icon>
            <span>Edit</span>
          </button>


          <button mat-menu-item (click)="onDispatchDelete(scholarship.id)">
            <mat-icon>delete</mat-icon>
            <span>Delete</span>
          </button>
        </mat-menu>
      </div>
        <div class="info" (click)="onView(scholarship)">

            <h5>
                <span class="label">Institution Name</span>
                <span class="Answer">{{scholarship.InstitutionNameOnAward}}</span>
            </h5>

            <h5>
                <span class="label">Phone</span>
                <span class="Answer">{{scholarship.PhoneNumber}}</span>
            </h5>

            <h5>
                <span class="label">Course of Study</span>
                <span class="Answer">{{getCourseOfStudy(scholarship.CourseOfStudy)}}</span>
            </h5>

            <h5>
              <span class="label">Duration</span>
              <span class="Answer">{{getDuration(scholarship.ScholarshipAwardDurationId)}}</span>
          </h5>

            <h5>
                <span class="label">State</span>
                <span class="Answer">{{getState(scholarship.State)}}</span>
            </h5>

        </div>
    </div>



</div>
 </div>
</div>
</main>
</div>
